import { render, staticRenderFns } from "./ItemRef.vue?vue&type=template&id=c3f00c4c&scoped=true&"
import script from "./ItemRef.vue?vue&type=script&lang=ts&"
export * from "./ItemRef.vue?vue&type=script&lang=ts&"
import style0 from "./ItemRef.vue?vue&type=style&index=0&id=c3f00c4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f00c4c",
  null
  
)

export default component.exports